<main id="main-wrapper">
    <div class="master-grid">
        <div class="t-row">
            <div class="col c--12">
                <div class="content-in ct-lg">
                    <h1 class="central-title">{{ title }}</h1>
                </div>
            </div>
        </div>
        <div class="t-row">
            <div class="col c--4 tablet--6 spec--6" *ngFor="let post of posts.reverse()">
                <div class="post-card">
                    <a routerLink="/blog/article/{{ post.id }}">
                        <img src="{{ post.image }}" alt="post image" class="post-img">
                    </a>
                    <div class="post-caption">
                        <h3 class="post-title">{{ post.title }}</h3>
                        <div class="post-footer">
                            <a routerLink="/blog/article/{{ post.id }}" class="rnd-btn"><span class="btn-txt">Lire le post</span> &nbsp; <i class="fas fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>